module.exports = __webpack_public_path__ + "img/Capture14.cbb54435.jpg";